/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Cta_TitleInputs */

const en_home_cta_title = /** @type {(inputs: Home_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open CADCraft in your browser`)
};

/**
* | output |
* | --- |
* | "Open CADCraft in your browser" |
*
* @param {Home_Cta_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_cta_title = /** @type {((inputs?: Home_Cta_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Cta_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_cta_title(inputs)
});
export { home_cta_title as "home.cta.title" }